(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qc-birthday-club-signup"] && !Shopify.designMode) return;
  try {
    

  (() => {
    function getCookie(name) {
      const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));

      return cookie
        ? decodeURIComponent(cookie.substring(name.length + 1))
        : '';
    }

    function initializeBirthdayClub(root) {
      if (!root || root.dataset.qcBirthdayInitialized === 'true') {
        return;
      }

      root.dataset.qcBirthdayInitialized = 'true';

      const portalId = root.dataset.portalId;
      const formGuid = root.dataset.formGuid;
      const birthdayProperty = root.dataset.birthdayProperty;

      const form = root.querySelector(
        '.qc-birthday-club__form'
      );

      const emailInput = root.querySelector(
        'input[name="email"]'
      );

      const birthdayInput = root.querySelector(
        'select[name="birthday_month"]'
      );

      const button = root.querySelector(
        'button[type="submit"]'
      );

      const success = root.querySelector(
        '.qc-birthday-club__success'
      );

      const error = root.querySelector(
        '.qc-birthday-club__error'
      );

      if (
        !form ||
        !emailInput ||
        !birthdayInput ||
        !birthdayProperty ||
        !button
      ) {
        return;
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!form.reportValidity()) {
          return;
        }

        const originalButtonText = button.textContent;

        error.hidden = true;
        success.hidden = true;

        button.disabled = true;
        button.textContent = 'SUBMITTING…';

        const context = {
          pageUri: window.location.href,
          pageName: document.title
        };

        const hutk = getCookie('hubspotutk');

        if (hutk) {
          context.hutk = hutk;
        }

        const payload = {
          submittedAt: String(Date.now()),

          fields: [
            {
              objectTypeId: '0-1',
              name: 'email',
              value: emailInput.value.trim()
            },
            {
              objectTypeId: '0-1',
              name: birthdayProperty,
              value: birthdayInput.value
            }
          ],

          context
        };

        try {
          const endpoint =
            `https://api.hsforms.com/submissions/v3/integration/submit/` +
            `${encodeURIComponent(portalId)}/` +
            `${encodeURIComponent(formGuid)}`;

          const response = await fetch(endpoint, {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify(payload)
          });

          const responseBody = await response
            .json()
            .catch(() => ({}));

          if (!response.ok) {
            throw new Error(
              responseBody.message ||
              'HubSpot rejected the form submission.'
            );
          }

          button.disabled = false;
          button.textContent = originalButtonText;

          form.reset();
          form.hidden = true;
          success.hidden = false;

        } catch (submissionError) {
          console.error(
            'HubSpot birthday form submission failed:',
            submissionError
          );

          error.hidden = false;
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
    }

    function initializeAllBirthdayClubs(scope) {
      const parent = scope || document;

      if (
        parent.matches &&
        parent.matches('[data-qc-birthday-club]')
      ) {
        initializeBirthdayClub(parent);
      }

      parent
        .querySelectorAll('[data-qc-birthday-club]')
        .forEach(initializeBirthdayClub);
    }

    function startBirthdayClub() {
      initializeAllBirthdayClubs(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        startBirthdayClub
      );
    } else {
      startBirthdayClub();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllBirthdayClubs(event.target);
      }
    );
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-hubspot-welcome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function getCookie(name) {
      const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));

      return cookie
        ? decodeURIComponent(cookie.substring(name.length + 1))
        : '';
    }

    function initializeSignup(root) {
      if (!root || root.dataset.qcInitialized === 'true') {
        return;
      }

      root.dataset.qcInitialized = 'true';

      const portalId = root.dataset.portalId;
      const formGuid = root.dataset.formGuid;
      const form = root.querySelector('.qc-welcome-banner__form');
      const input = root.querySelector('input[name="email"]');
      const button = root.querySelector('button[type="submit"]');
      const success = root.querySelector('.qc-welcome-banner__success');
      const error = root.querySelector('.qc-welcome-banner__error');

      if (!form || !input || !button) {
        return;
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!form.reportValidity()) {
          return;
        }

        const originalButtonText = button.textContent;

        error.hidden = true;
        success.hidden = true;
        button.disabled = true;
        button.textContent = 'SUBMITTING…';

        const context = {
          pageUri: window.location.href,
          pageName: document.title
        };

        const hutk = getCookie('hubspotutk');

        if (hutk) {
          context.hutk = hutk;
        }

        const payload = {
          submittedAt: String(Date.now()),
          fields: [
            {
              objectTypeId: '0-1',
              name: 'email',
              value: input.value.trim()
            }
          ],
          context
        };

        try {
          const endpoint =
            `https://api.hsforms.com/submissions/v3/integration/submit/` +
            `${encodeURIComponent(portalId)}/` +
            `${encodeURIComponent(formGuid)}`;

          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });

          const responseBody = await response
            .json()
            .catch(() => ({}));

          if (!response.ok) {
            throw new Error(
              responseBody.message ||
              'HubSpot rejected the form submission.'
            );
          }

          form.hidden = true;
          success.hidden = false;
        } catch (submissionError) {
          console.error(
            'HubSpot form submission failed:',
            submissionError
          );

          error.hidden = false;
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
    }

    function initializeAll(scope) {
      const parent = scope || document;

      if (
        parent.matches &&
        parent.matches('[data-qc-hs-signup]')
      ) {
        initializeSignup(parent);
      }

      parent
        .querySelectorAll('[data-qc-hs-signup]')
        .forEach(initializeSignup);
    }

    function start() {
      initializeAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
